export default __webpack_public_path__ + "img/PIC_HE_Efficiency_fw_de_de_92813_92813.jpg";